module.exports = __webpack_public_path__ + "media/site_templates/www.carpetcleaning.agency/images/splash-1163a3087a94b9070af6c80876241a12.jpg";